<mat-drawer-container  class="conteiner-desktop">
    <mat-drawer disableClose #drawer [ngClass]="{'sidenav-desktop': !isPhone}" [mode]="isPhone? 'push': 'side'" [opened]="!isPhone">
        <div class="navigation-list" [ngClass]="{'navigation-list-desktop': !isPhone}">

            <div class="logo-container" *ngIf="!isPhone">
                <img
                    *ngIf="logoUrl; else defaultLogo"
                    [src]="logoUrl"
                    alt="Logo da Conta"
                    class="logoUrl"
                />
                <ng-template #defaultLogo>
                    <img
                        src="../../../../assets/images/logo/logo-hudlygo.png"
                        alt="Logo padrão"
                        class="logoUrl"
                    />
                </ng-template>
            </div>

            <div class="account-info" *ngIf="authService.isLogged()">
                <div class="account-details">
                    <div class="info-row" *ngIf="accountName && accountName !== 'Carregando...'">
                        <span class="info-label">Acesso:</span>
                        <span class="info-value" [title]="accountName">{{ accountName }}</span>
                    </div>
                    <div class="info-row" *ngIf="!accountName || accountName === 'Carregando...'">
                        <span class="info-label">Carregando informações...</span>
                    </div>
                </div>
            </div>

            <mat-nav-list  class="nav" role="navigation">

                <mat-list-item class="mt-4"  userRole permission="{{accessControl.ROLE_PERFIL_READ}}" routerLink="/profile" [routerLinkActive]="['is-active']"(click)="handleRedirectTo('profile')">
                    <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;">account_circle</mat-icon>
                    <span mat-line style="font-size: 15px;">Perfil</span>
                </mat-list-item>

                <mat-list-item
                    userRole permission="{{accessControl.ROLE_DASHBOARD_READ}}"
                    class="second-item"
                    routerLink="/dashboard-inicial"
                    #dashboardActive="routerLinkActive"
                    [routerLinkActive]="['is-active']">
                    <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">
                        {{ dashboardActive.isActive ? 'dashboard_customize' : 'dashboard' }}
                    </span>
                    <span mat-line style="font-size: 15px;">Painel Geral</span>
                </mat-list-item>

                <mat-accordion userRole permission="{{accessControl.ROLE_REGISTER_READ}}">
                    <mat-expansion-panel hideToggle #cadastroPanel="matExpansionPanel"
                        [expanded]="isCadastroActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isCadastroPanelActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">app_registration</span>
                                    <span mat-line style="font-size: 14px;">Cadastro</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="cadastroPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            *ngIf="!this.isAccountConorOwner"
                            userRole permission="{{accessControl.ROLE_USERS_READ}}"
                            routerLink="/users-management"
                            #usersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">group</span>
                            <span mat-line style="font-size: 15px;">Usuários</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_CUSTOMERS_READ}}"
                            routerLink="/customers"
                            #customersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;">person</mat-icon>
                            <span mat-line style="font-size: 15px;">Clientes</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_PRODUCTS_READ}}"
                            routerLink="/products"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons"> shopping_bag </span>
                            <span mat-line style="font-size: 15px;">Produtos</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_VEHICLES_READ}}"
                            routerLink="/vehicles"
                            #vehiclesActive="routerLinkActive"
                            [routerLinkActive]="isVehiclesActive() ? ['sub-menu-active'] : []"
                            [routerLinkActiveOptions]="{ exact: false }">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">directions_car</span>
                            <span mat-line style="font-size: 15px;">Veículos</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_VEHICLES_READ}}"
                            routerLink="/vehicles/seguros"
                            #vehiclesWithProductActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">shield</span>
                            <span mat-line style="font-size: 15px;">Seguros</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion userRole permission="{{accessControl.ROLE_DESK_READ}}">
                    <mat-expansion-panel hideToggle #escritorioPanel="matExpansionPanel"
                        [expanded]="isEscritorioActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isEscritorioPanelActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">business</span>
                                    <span mat-line style="font-size: 14px;">Escritório</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="escritorioPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_SYSTEM_DOCS_READ}}"
                            routerLink="/documentos"
                            #documentsActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">description</span>
                            <span mat-line style="font-size: 15px;">Meus Documentos</span>
                        </mat-list-item>

                        <!-- Documento interno, exclusivo do acesso owner/master -->
                        <mat-list-item
                            *ngIf="isAccountConorOwner"
                            routerLink="/mirror-policies"
                            #mirrorPoliciesActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">content_copy</span>
                            <span mat-line style="font-size: 15px;">Propostas de Seguro</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <!-- Integrações Seguradora: o que vem da OON, com apólice e coberturas próprias -->
                <mat-accordion *ngIf="isOonEnabled">
                    <mat-expansion-panel hideToggle #seguradoraPanel="matExpansionPanel"
                        [expanded]="isSeguradoraActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isSeguradoraActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">handshake</span>
                                    <span mat-line style="font-size: 14px;">Integrações Seguradora</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="seguradoraPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            routerLink="/oon-policies"
                            #oonPoliciesActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">verified_user</span>
                            <span mat-line style="font-size: 15px;">Apólices</span>
                        </mat-list-item>

                        <mat-list-item
                            routerLink="/oon-sinisters"
                            #oonSinistersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">report_problem</span>
                            <span mat-line style="font-size: 15px;">Sinistros</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-list-item (click)="handleLogout()" class="last-item" >
                    <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons-round">logout</mat-icon>
                    <span mat-line style="font-size: 15px;">Sair</span>
                </mat-list-item>

            </mat-nav-list>

        </div>



    </mat-drawer>

    <mat-drawer-content [ngClass]="{'desktop-content': !isPhone,   'phone-content' : isPhone}" >
        <ng-content></ng-content>

    </mat-drawer-content>
</mat-drawer-container>